module.exports = __webpack_public_path__ + "img/sms.882b0b1c.png";